export const TG_LAUNCH_PARAMS_KEY = 'telegram_launch_params';
export const TG_WEBSITE_USER_KEY = 'telegram_website_user';
